import { CONFIG_PERMISSIONS } from '../constants/ConfigPermission';

export const checkForDomainConfig = (
  config: number,
  showSportsComponents: boolean,
  showCasinoComponents: boolean
) => {
  switch (config) {
    case CONFIG_PERMISSIONS.live_casino:
    case CONFIG_PERMISSIONS.indian_casino:
    case CONFIG_PERMISSIONS.casino:
      return showCasinoComponents;

    case CONFIG_PERMISSIONS.football:
    case CONFIG_PERMISSIONS.tennis:
    case CONFIG_PERMISSIONS.cricket:
    case CONFIG_PERMISSIONS.sports:
      return showSportsComponents;

    default:
      return false;
  }
};
